import cn from 'classnames';
import * as React from 'react';

import * as styles from './authorSection.css';

export const AuthorSection = (props: React.PropsWithChildren<{}>) => {
  return <div className={cn(styles['section'])}>{props.children}</div>;
};
